import { render, staticRenderFns } from "./Moment.vue?vue&type=template&id=6b51209c"
import script from "./Moment.vue?vue&type=script&lang=js"
export * from "./Moment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports